
@if (product$ | async; as product) {
  <div class="container price-search-container">
    @for (engine of product?.priceSearchEngineUrls; track engine) {
      <div class="priceSearchEngineUrls">
        <a target="_blank" class="red" href="{{ engine.url }}">{{ engine.title }}</a>
      </div>
    }
  </div>
}
